import React, { FC, memo, ReactElement } from 'react';
import Slider from 'react-slick';

import 'common/styles/SlickSlider.scss';

import ProviderInfoCard from '../ProviderInfoCard/ProviderInfoCard';
import './ProvidersSlider.scss';

export type TProvidersSlider$Provider = {
  id: string;
  slug: string;
  firstName: string;
  lastName: string;
  publicName: string;
  companyName: string;
  avatarUrl: string;
  rating: number;
  feedbacksCount: number;
  shortDescription: string;
  cityName: string;
  dateRegistered: string;
  featured: boolean;
  yearsOfExperience: number;
  yearEstablished: number;
};

type ProvidersSlider$Props = {
  providers: TProvidersSlider$Provider[];
  regionName?: string;
  cityName?: string;
  cityLat?: number;
  cityLong?: number;
};

const sliderSettings = {
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const ProvidersSlider: FC<ProvidersSlider$Props> = (props) => {
  const { cityName, cityLat, cityLong, regionName } = props;

  const renderItem = (provider: TProvidersSlider$Provider, index: number): ReactElement => {
    return (
      <div className="providersSlider__itemWrap" key={provider.id}>
        <div className="providersSlider__item">
          <ProviderInfoCard
            {...provider}
            cityName={cityName || provider.cityName}
            cityLat={Number(cityLat)}
            cityLong={Number(cityLong)}
            regionName={regionName}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="providersSlider">
      {!!props.providers.length && <Slider {...sliderSettings}>{props.providers.map(renderItem)}</Slider>}
    </div>
  );
};

export default memo(ProvidersSlider);
